module.exports = __webpack_public_path__ + "static/oec_welfare.ce6dd46a.png";